module.exports = __webpack_public_path__ + "img/img3_5.9017ad63.jpeg";